import { render, staticRenderFns } from "./ficheContact.vue?vue&type=template&id=d0ad0af6"
import script from "./ficheContact.vue?vue&type=script&lang=js"
export * from "./ficheContact.vue?vue&type=script&lang=js"
import style0 from "./ficheContact.vue?vue&type=style&index=0&id=d0ad0af6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports